import { Component, OnInit, ViewChild, ElementRef, isDevMode } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { FeesService } from '../../../../fees.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-tryout-payment-info',
  templateUrl: './tryout-payment-info.component.html',
  styleUrls: ['./tryout-payment-info.component.css']
})
export class TryoutPaymentInfoComponent implements OnInit {
  @ViewChild('PaymentChoices') PaymentChoices: ElementRef;
  public is_wizard_init = true;
  public isStep3WizardNextButtonClicked = 0;
  public is_active_step1_wizard = false;
  public dateValue: Date = new Date();
  public Frequencys: any[];
  public onDays: any[];
  public onNumbers: any[];
  public onTheWeeks: any[];
  public errorMessages = {};
  public programId: Number;
  public routeParams;
  public paymentStructureForm: FormGroup;
  public payment_installment_amount: number;
  public items: FormArray;

  public isHideCreateButton = false;
  public isShowPaymentOptions = false; //Show created payment plan.
  public isShowPayementsToPay = false; // Show Payment setup.
  public isShowSubmitButton = false;
  public isShowNextButton = false;
  public isShowCreateButton = true;

  public isShowPreviousButton = true;
  public isShowSaveButton = false;
  public isShowCancelButton = false;

  public isHidePaymentDates = false;
  public isHideWeekOfTheMonth = false;
  public onlyDigitPattern: RegExp;
  public currencyPattern: RegExp;

  public numberOfPayments: number;
  public NoOfPaymentBackup: number;
  public TotalAmountOfPayment = 0;

  public minDate: Date = new Date();
  // hold multiple fee structure.
  public FeeStructureArray: any = [];
  public FeePaymentPlanListArray: any = [];
  public isShowAddAnotherPaymentPlanButton: boolean;

  // Hold edit payment data.
  public paymentChoice: number;
  public clubFeePaymentPlanID: number;

  constructor(private activeRoute: ActivatedRoute,
    private router: Router,
    private feesService: FeesService,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fb: FormBuilder
  ) {

    this.onlyDigitPattern = /^-?(0|[0-9]\d*)?$/;
    this.currencyPattern = /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/;
    this.Frequencys = [
      { 'key': 1, 'value': 'Every Month' },
      { 'key': 2, 'value': 'Every Other Month' },
      { 'key': 3, 'value': 'Every Week' },
      { 'key': 4, 'value': 'Every Other Week' }
    ];
    this.onDays = [
      '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15',
      '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28'
    ];
    this.onNumbers = [
      { 'key': 1, 'value': 'First' },
      { 'key': 2, 'value': 'Second' },
      { 'key': 3, 'value': 'Third' },
      { 'key': 4, 'value': 'Fourth' },
      { 'key': 5, 'value': 'Last' },
    ];
    this.onTheWeeks = [
      { 'key': 1, 'value': 'Monday' },
      { 'key': 2, 'value': 'Tuesday' },
      { 'key': 3, 'value': 'Wednesday' },
      { 'key': 4, 'value': 'Thursday' },
      { 'key': 5, 'value': 'Friday' },
      { 'key': 6, 'value': 'Saturday' },
      { 'key': 7, 'value': 'Sunday' },
    ];
    this.errorMessages = {
      'errorPaymentChoicesOption': 'Please select an option.',
      'errorFirstPaymentDueAtRegistrationOption': 'Please select an option.',
      'errorFeeAmountRequired': 'This field is required.',
      'errorNumberOfPaymentsRequired': 'This field is required.',
      'errorFeeAmountPattern': 'Please enter only number.',
      'errorNumberOfPaymentsPattern': 'Please enter only number.',
      'errorBillingStartDateRequired': 'This field is required.',
      'errorPaymentFrequencyRequired': 'This field is required.',
      'errorPaymentDatesRequired': 'This field is required.',
      'errorOnDateRequired': 'This field is required.',
      'errorPaymentNumberRequired': 'This field is required.',
      'errorOnThWeekRequired': 'This field is required.',
      'errorNumberOfPaymentsMinlength': 'Please enter at least 1 number.',
      'errorNumberOfPaymentsMaxlength': 'Please enter no more than 2 number.',
    };
    this.isShowAddAnotherPaymentPlanButton = true;
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    this.programId = this.routeParams.id;
    this.paymentStructureForm = this.fb.group({
      //PaymentChoices: ['', [Validators.required]],
      FeeAmount: [{ value: '', disabled: true }, Validators.compose([Validators.required])],
      DueAtRegistration: ['', [Validators.required]],
      FirstPaymentDueAtRegistration: [''],
      NumberOfPayments: [''],
      DueOnSpecificDate: ['', [Validators.required]],
      BillingStartDate: [''],
      PaymentFrequency: [''],
      PaymentDates: [''],
      OnDate: [''],
      PaymentNumber: [''],
      OnThWeek: [''],
      items: this.fb.array([])
    });

    this.getFeeDataNew(this.routeParams.feeId, false);
    //console.log("FeePaymentPlanListArray:", this.FeePaymentPlanListArray);
    const FORM = this.paymentStructureForm.value;
    FORM.PaymentChoices = '1';
    this.paymentStructureForm.get('FeeAmount').enable();    
  }

  // New code added on 19-02-2019.
  getFeeDataNew(fee_id: number, isAddAddtionalPayment: boolean) {
    this.spinnerService.show();
    this.FeePaymentPlanListArray.length = 0;
    this.feesService.getFees(fee_id.toString()).subscribe((response: any) => {
      this.spinnerService.hide();
      const rs = response.data;
      console.log("getFeeDataNew():", rs);
      if (rs.clubFeePaymentPlanList.length !== 0) {
        //this.lockPaymentSetup();
        if (isAddAddtionalPayment) {
          this.isShowAddAnotherPaymentPlanButton = true;
        } else {
          this.isShowAddAnotherPaymentPlanButton = false;
        }
        this.isHideCreateButton = false;
        this.isShowPaymentOptions = true; //Show created payment plan.
        this.isShowPayementsToPay = false; // Show Payment setup.
        this.FeePaymentPlanListArray = Array.from(rs.clubFeePaymentPlanList);
      }
    });
  }

  isPaymentChoicesValid() {
    return true;
    //this.paymentStructureForm.get('PaymentChoices').errors
    //  && (this.paymentStructureForm.get('PaymentChoices').touched
    //    || this.paymentStructureForm.get('PaymentChoices').dirty);
  }

  isFirstPaymentDueAtRegistrationValid() {
    return this.paymentStructureForm.get('FirstPaymentDueAtRegistration').errors
      && (this.paymentStructureForm.get('FirstPaymentDueAtRegistration').touched
        || this.paymentStructureForm.get('FirstPaymentDueAtRegistration').dirty);
  }

  isFeeAmountValid() {
    return this.paymentStructureForm.get('FeeAmount').errors
      && (this.paymentStructureForm.get('FeeAmount').touched
        || this.paymentStructureForm.get('FeeAmount').dirty);
  }

  isPaymentFrequencyValid() {
    return this.paymentStructureForm.get('PaymentFrequency').errors
      && (this.paymentStructureForm.get('PaymentFrequency').touched
        || this.paymentStructureForm.get('PaymentFrequency').dirty);
  }

  isNumberOfPaymentsValid() {
    return this.paymentStructureForm.get('NumberOfPayments').errors
      && (this.paymentStructureForm.get('NumberOfPayments').touched
        || this.paymentStructureForm.get('NumberOfPayments').dirty);
  }

  isBillingStartDateValid() {
    return this.paymentStructureForm.get('BillingStartDate').errors
      && (this.paymentStructureForm.get('BillingStartDate').touched
        || this.paymentStructureForm.get('BillingStartDate').dirty);
  }

  isPaymentDatesValid() {
    return this.paymentStructureForm.get('PaymentDates').errors
      && (this.paymentStructureForm.get('PaymentDates').touched
        || this.paymentStructureForm.get('PaymentDates').dirty);
  }

  isOnDateValid() {
    return this.paymentStructureForm.get('OnDate').errors
      && (this.paymentStructureForm.get('OnDate').touched
        || this.paymentStructureForm.get('OnDate').dirty);
  }

  isPaymentNumberValid() {
    return this.paymentStructureForm.get('PaymentNumber').errors
      && (this.paymentStructureForm.get('PaymentNumber').touched
        || this.paymentStructureForm.get('PaymentNumber').dirty);
  }

  isOnThWeekValid() {
    return this.paymentStructureForm.get('OnThWeek').errors
      && (this.paymentStructureForm.get('OnThWeek').touched
        || this.paymentStructureForm.get('OnThWeek').dirty);
  }

  //isFullPayOnlySelected() {
  //  return true;
  //  //(!!this.paymentStructureForm.get('PaymentChoices'))
  //  //  && (this.paymentStructureForm.get('PaymentChoices').value === '1');
  //}

  //isPaymentPlanOnlySelected() {
  //  return false;

  //  //(!!this.paymentStructureForm.get('PaymentChoices'))
  //  //  && (this.paymentStructureForm.get('PaymentChoices').value === '0');
  //}

  isPaymentDatesOnDaySelected() {
    return (!!this.paymentStructureForm.get('PaymentDates'))
      && (this.paymentStructureForm.get('PaymentDates').value === '1');
  }

  isPaymentDatesOnTheSelected() {
    return (!!this.paymentStructureForm.get('PaymentDates'))
      && (this.paymentStructureForm.get('PaymentDates').value === '0');
  }

  isFirstPaymentDueAtRegistrationYesSelected() {
    return (!!this.paymentStructureForm.get('FirstPaymentDueAtRegistration'))
      && (this.paymentStructureForm.get('FirstPaymentDueAtRegistration').value === '1');
  }

  isFirstPaymentDueAtRegistrationNoSelected() {
    return (!!this.paymentStructureForm.get('FirstPaymentDueAtRegistration'))
      && (this.paymentStructureForm.get('FirstPaymentDueAtRegistration').value === '0');
  }

  isDueAtRegistrationNoSelected() {
    return (!!this.paymentStructureForm.get('DueAtRegistration'))
      && (this.paymentStructureForm.get('DueAtRegistration').value === '0');
  }

  firstPaymentDueAtRegistrationChange(event) {
    event.stopPropagation();



  }

  removeValidaion(name) {
    const control = this.paymentStructureForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  createItem(description, amount, duedate): FormGroup {
    return this.fb.group({
      payment_description: [description],
      payment_amount: [amount],
      due_date: [duedate],
    });
  }

  createPaymentsControl() {
    if (this.items) {
      this.clearFormArray(this.items);
    }
    this.items = this.paymentStructureForm.get('items') as FormArray;
    const radix = 10;
    const l = parseInt(this.paymentStructureForm.get('NumberOfPayments').value, radix);
    for (let i = 0; i < l; i++) {   
      this.items.push(this.createItem('', this.payment_installment_amount, this.dateValue));
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  resetForm() {
    this.paymentStructureForm.reset();
  }

  resetNumberOfPaymentValue() {
    const radix = 10;
    const nop = parseInt(this.paymentStructureForm.get('NumberOfPayments').value, radix) - 1;
    this.paymentStructureForm.patchValue({ 'NumberOfPayments': nop });
  }

  setFormArray = (formArray: FormArray) => {
    if (formArray.length !== 0) {
      const radix = 10;
      const l = parseInt(this.paymentStructureForm.get('NumberOfPayments').value, radix);
      for (let i = 0; i < l; i++) {
        this.items.at(i).patchValue({ payment_amount: this.payment_installment_amount });
      }
    }
  }

  getPaymentInstallmentAmount() {
    const FEE_AMOUNT = this.paymentStructureForm.get('FeeAmount').value;
    const NO_OF_PAYMENT = this.paymentStructureForm.get('NumberOfPayments').value;
    this.payment_installment_amount = FEE_AMOUNT / NO_OF_PAYMENT;
    console.log("this.payment_installment_amount:", this.payment_installment_amount);
  }

  disableControl(name) {
    const CONTROL = this.paymentStructureForm.get(name);
    CONTROL.disable();
  }

  enableControl(name) {
    const CONTROL = this.paymentStructureForm.get(name);
    CONTROL.enable();
  }

  lockPaymentSetup() {
    //this.disableControl('PaymentChoices');
    this.disableControl('FeeAmount');
    this.disableControl('FirstPaymentDueAtRegistration');
    this.disableControl('NumberOfPayments');
    this.disableControl('BillingStartDate');
    this.disableControl('PaymentFrequency');
    this.disableControl('PaymentDates');
    this.disableControl('OnDate');
    this.disableControl('PaymentNumber');
    this.disableControl('OnThWeek');
  }

  unlockPaymentSetup() {
   // this.enableControl('PaymentChoices');
    this.enableControl('FeeAmount');
    this.enableControl('FirstPaymentDueAtRegistration');
    this.enableControl('NumberOfPayments');
    this.enableControl('BillingStartDate');
    this.enableControl('PaymentFrequency');
    this.enableControl('PaymentDates');
    this.enableControl('OnDate');
    this.enableControl('PaymentNumber');
    this.enableControl('OnThWeek');
  }

  createPayments() {
    this.lockPaymentSetup();
    this.getPaymentInstallmentAmount();
    this.createPaymentsControl();
    //if (!this.isFullPayOnlySelected()) {
    //  this.isHideCreateButton = true;
    //  this.isShowNextButton = true;
    //  this.isShowSubmitButton = false;
    //  this.isShowPaymentOptions = false;
    //  this.isShowPayementsToPay = true;
    //} else {
      this.isHideCreateButton = true;
      this.isShowNextButton = false;
      this.isShowSubmitButton = true;
      this.isShowPaymentOptions = true;
      this.isShowPayementsToPay = false;
    //}
  }

  calculateDueDates(params) {
    length = params.paymentCount;
    const resultDates = []; // paymentCount
    resultDates.push(params.Startdate); // first date
    let calculatedDate = moment(params.Startdate);
    if (params.frequency === 1 || params.frequency === 2 || params.frequency === 3 || params.frequency === 4) {
      for (let i = 0; i < length - 1; i++) {
        if (params.frequency === 1) { /*every month*/
          if (params.paymentdate !== 0) {
            calculatedDate = calculatedDate.month(i + 2).set({ 'date': params.paymentdate });
          } else {
            calculatedDate = calculatedDate.isoWeeks(params.weeks).month(i + 2).set({
              'day': calculatedDate.isoWeekday() >= 3 ? params.paymentday + 7 : params.paymentday
            });
          }
        } else if (params.frequency === 2) {/*every other month*/
          if (params.paymentdate !== 0) {
            calculatedDate = calculatedDate.month(i * 2 + 2).set({
              'day': calculatedDate.isoWeekday() >= 3 ? params.paymentday + 7 : params.paymentday
            });
          } else {
            calculatedDate = calculatedDate.isoWeeks(params.weeks).month(i * 2 + 2).set({ 'day': params.paymentday });
          }
        } if (params.frequency === 3) {/*every week*/
          calculatedDate = calculatedDate.isoWeekday(params.paymentday + 7);
        } else if (params.frequency === 4) {/*every other week*/
          calculatedDate = calculatedDate.isoWeekday(params.paymentday * 7 + 1);
        }
        resultDates.push(calculatedDate.format());
      }
      return resultDates;
    }
  }

  onChangeDueDate() {
    //console.log("status1", this.paymentStructureForm.status);
    return (this.paymentStructureForm.status === 'INVALID')
  }
  /**
  * Create Payment Structure.
  */
  onCreate(event, formStatus) {
    event.stopPropagation();
    
    if (formStatus === 'VALID') {
      this.addFeeStructure();
      const FORM = this.paymentStructureForm.getRawValue();
      const FEE_ID = this.routeParams.feeId;
      //console.log("FORM:", FORM);
      //const OBJ = {
      //  paymentchoice: 1,
      //  setup: 3,
      //  clubprogramfeeID: (typeof FEE_ID === 'undefined') ? 0 : FEE_ID.toString(),
      //  amount: Number(FORM.FeeAmount),
      //  dueatregistration: Number(FORM.DueAtRegistration),
      //  dueondate: FORM.DueOnSpecificDate
      //};
      const OBJ = {
        paymentchoice: 1,
        setup: 3,
        clubprogramfeeID: (typeof FEE_ID === 'undefined') ? 0 : FEE_ID.toString(),
        amount: Number(FORM.FeeAmount),
        dueatregistration: Number(FORM.DueAtRegistration),
        dueondate: FORM.DueOnSpecificDate,

        feeStructure: '',
        numberofpayments: 1,
        firstpaymentdueatreg: 0,
        billingstartdate: '',
        payondayordate: 0,
        payondatevalue: 0, // Select Date
        payondayvalue: "", // Day of the Week
        PaymentNumber: 0, // Week of the Month (TODO: Dynamic)
        paymentfrequency: FORM.PaymentFrequency,
        clubFeePaymentPlanList: []
      };

      //console.log("OBJ:", OBJ);
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      
      this.feesService.saveFeeStructure(OBJ).subscribe((data: any) => {
        event.target.innerHTML = 'Create';
        //event.target.disabled = false;
        //this.isShowNextButton = false;
        //this.isShowSubmitButton = true;
        //this.isShowPaymentOptions = true;
        //this.isShowPayementsToPay = false;
        //this.paymentStructureForm.reset();
        //this.getFeeDataNew(this.routeParams.feeId, true);
        this.alertMessage('success', data.result);
        this.getFeeDataNew(this.routeParams.feeId, true);
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateUi();
      this.isStep3WizardNextButtonClicked = 1;
      this.alertMessage('error', 'Please fill all necessary fields.');
    }
  }

  removePayment(event, index: number) {
    event.preventDefault();
    this.items.removeAt(index);
    this.resetNumberOfPaymentValue();
    this.getPaymentInstallmentAmount();
    this.setFormArray(this.items);
    if (this.items.length === 0) {
      const numberOfPayments = { 'NumberOfPayments': this.NoOfPaymentBackup.toString() };
      this.paymentStructureForm.patchValue(numberOfPayments);
      this.unlockPaymentSetup();
      this.isHideCreateButton = false;
      this.isShowNextButton = false;
      this.isShowSubmitButton = false;
      this.isShowPaymentOptions = false;
      this.isShowPayementsToPay = false;
    }
  }

  removePaymentSchedule(event) {
    event.preventDefault();
    const numberOfPayments = { 'NumberOfPayments': this.NoOfPaymentBackup.toString() };
    this.clearFormArray(this.items);
    this.paymentStructureForm.patchValue(numberOfPayments);
    this.unlockPaymentSetup();
    this.isHideCreateButton = false;
    this.isShowNextButton = false;
    this.isShowSubmitButton = false;
    this.isShowPaymentOptions = false;
    this.isShowPayementsToPay = false;
  }

  /**
   * Allow user to change the amount of any individual payment and update
   * the remaining amount equally across the number of payments left.
   *
   * @param event
   * @param index
   */
  updateNumberOfPayments(event, index: number) {
    const RADIX = 10;
    const NEW_AMOUNT = parseInt(event.target.value, RADIX);
    if (isNaN(NEW_AMOUNT)) {
    } else {

      //const FEE_AMOUNT = parseInt(this.paymentStructureForm.get('FeeAmount').value, RADIX);
      //const NO_OF_PAYMENT = parseInt(this.paymentStructureForm.get('NumberOfPayments').value, RADIX) - 1;
      //const NM = (FEE_AMOUNT - NEW_AMOUNT) / NO_OF_PAYMENT;
      //const l = parseInt(this.paymentStructureForm.get('NumberOfPayments').value, RADIX);

      const FEE_AMOUNT = Number(this.TotalAmountOfPayment);
      const NO_OF_PAYMENT = Number(this.numberOfPayments) - 1;
      const NM = (FEE_AMOUNT - NEW_AMOUNT) / NO_OF_PAYMENT;
      const l = Number(this.numberOfPayments);
      for (let i = 0; i < l; i++) {
        if (i !== index) {
          this.items.at(i).patchValue({ payment_amount: NM });
        }
      }
      //this.TotalAmountOfPayment = amount;
      // this.items.at(index).patchValue({ payment_amount: NEW_AMOUNT + ".00" });
    }
  }

  validateUi() {
    Object.keys(this.paymentStructureForm.controls).forEach(field => {
      const control = this.paymentStructureForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  alertMessage(status, message) {
    if (status === 'success') {
      const toast = this.notificationsService.success('Success', message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    } else if (status === 'error') {
      const toast = this.notificationsService.error('Error', message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    }
  }

  paymentFrequencyChange(e) {
    e.stopPropagation();
    const PAYMENT_FREQUENCY = this.paymentStructureForm.get('PaymentFrequency').value;
    if (PAYMENT_FREQUENCY === '3' || PAYMENT_FREQUENCY === '4') {
      //this.paymentStructureForm.patchValue({ PaymentDates: '0' });
    }
  }

  /* Hold fee structure data. */
  addFeeStructure() {
    const FORM = this.paymentStructureForm.getRawValue();
    const feeStructArray = [];
    if (FORM.PaymentChoices === '0') {
      for (const i in FORM.items) {
        if (FORM.items.hasOwnProperty(i)) {
          const arr = {
            number: i,
            clubprogramfeeID: this.routeParams.feeId,
            name: FORM.items[i].payment_description,
            amount: FORM.items[i].payment_amount,
            duedate: FORM.items[i].due_date,
          };
          feeStructArray.push(arr);
        }
      }
    }
    const PaymentPlan = {
      "paymentchoice": Number(FORM.PaymentChoices),
      "amount": Number(FORM.FeeAmount),
      "billingstartdate": FORM.BillingStartDate,
      "numberofpayments": Number(FORM.NumberOfPayments),
      "clubFeeStructure": feeStructArray
    }
    this.FeePaymentPlanListArray.push(PaymentPlan);
  }

  addAnotherPaymentPlan(event) {
    event.stopPropagation();
    this.isShowNextButton = false;
    this.isShowSubmitButton = false;
    //Show created payment plan
    this.isShowPaymentOptions = true;
    this.isShowPayementsToPay = false;
    this.isHideCreateButton = false;
    this.unlockPaymentSetup();
    this.paymentStructureForm.reset();
  }

  paymentChoiceSelection() {
    const FORM = this.paymentStructureForm.value;
    if (FORM.PaymentChoices === '1') {
      this.resetPaymentPlanFields();
    } else {
      this.resetFullPayFields();
    }
  }

  paymentChoicesChange(event) {
    event.stopPropagation();
    this.paymentChoiceSelection();
  }

  /* Add Full Pay Fields Validation */
  addFPValidation() {
    this.paymentStructureForm.get("FeeAmount").setValidators([Validators.required]);
    this.paymentStructureForm.get('FeeAmount').updateValueAndValidity();

    this.paymentStructureForm.get("DueAtRegistration").setValidators([Validators.required]);
    this.paymentStructureForm.get('DueAtRegistration').updateValueAndValidity();

    
    if (this.isDueAtRegistrationNoSelected()) {
      this.paymentStructureForm.get("DueOnSpecificDate").setValidators([Validators.required]);
      this.paymentStructureForm.get('DueOnSpecificDate').updateValueAndValidity();
    } else {
      this.resetControl("DueOnSpecificDate");
    }
    //this.isShowNextButton = new
  }

  /* Add Payment Plan Fields Validation */
  addPPValidation() {
    this.paymentStructureForm.get("FeeAmount").setValidators([Validators.required]);
    this.paymentStructureForm.get('FeeAmount').updateValueAndValidity();
    this.paymentStructureForm.get("FirstPaymentDueAtRegistration").setValidators([Validators.required]);
    this.paymentStructureForm.get('FirstPaymentDueAtRegistration').updateValueAndValidity();
    this.paymentStructureForm.get("NumberOfPayments").setValidators(Validators.compose([
      Validators.required, Validators.minLength(1), Validators.maxLength(2), Validators.pattern(this.onlyDigitPattern)
    ]));
    this.paymentStructureForm.get('NumberOfPayments').updateValueAndValidity();
    this.paymentStructureForm.get("BillingStartDate").setValidators([Validators.required]);
    this.paymentStructureForm.get('BillingStartDate').updateValueAndValidity();
    this.paymentStructureForm.get("PaymentFrequency").setValidators([Validators.required]);
    this.paymentStructureForm.get('PaymentFrequency').updateValueAndValidity();
    this.paymentStructureForm.get("PaymentDates").setValidators([Validators.required]);
    this.paymentStructureForm.get('PaymentDates').updateValueAndValidity();

    if (this.isPaymentDatesOnDaySelected()) {
      this.paymentStructureForm.get("OnDate").setValidators([Validators.required]);
      this.paymentStructureForm.get('OnDate').updateValueAndValidity();
    } else {
      this.resetControl("OnDate");
    }

    if (this.isPaymentDatesOnTheSelected()) {
      this.paymentStructureForm.get("PaymentNumber").setValidators([Validators.required]);
      this.paymentStructureForm.get('PaymentNumber').updateValueAndValidity();
      this.paymentStructureForm.get("OnThWeek").setValidators([Validators.required]);
      this.paymentStructureForm.get('OnThWeek').updateValueAndValidity();
    } else {
      this.resetControl("PaymentNumber");
      this.resetControl("OnThWeek");
    }
  }

  resetControl(name) {
    const control = this.paymentStructureForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
    //this.paymentStructureForm.get('FeeAmount').enable();
  }

  resetFullPayFields() {
    this.resetControl("FeeAmount");
    this.resetControl("DueAtRegistration");
    this.resetControl("DueOnSpecificDate");
    this.addPPValidation();
  }

  resetPaymentPlanFields() {
    this.resetControl("FeeAmount");
    this.resetControl("FirstPaymentDueAtRegistration");
    this.resetControl("NumberOfPayments");
    this.resetControl("BillingStartDate");
    this.resetControl("PaymentFrequency");
    this.resetControl("PaymentDates");
    this.resetControl("OnDate");
    this.resetControl("PaymentNumber");
    this.resetControl("OnThWeek");
    this.addFPValidation();
  }

  DueAtRegistrationChange(event) {
    event.stopPropagation();
    //console.log("this.paymentStructureForm.get('DueAtRegistration').value", this.paymentStructureForm.get('DueAtRegistration').value);
    if (this.isDueAtRegistrationNoSelected()) {
      this.paymentStructureForm.get("DueOnSpecificDate").setValidators([Validators.required]);
      this.paymentStructureForm.get('DueOnSpecificDate').updateValueAndValidity();
    } else {
      this.resetControl("DueOnSpecificDate");
      this.removeValidaion("DueOnSpecificDate");
    }
  }

  paymentDatesChange(event) {
    event.stopPropagation();
    this.addPPValidation();
  }

  /* ======================== Save & Delete server side. ======================== */

  /* Redirect to Billing Information page. */
  onPrevious(event) {
    event.stopPropagation();
    const RP = this.routeParams;
    this.router.navigate(['/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step2/' + RP.feeId]);
  }

  /* Redirect to fee listing page. */
  onSubmit() {
    const RP = this.routeParams;
    this.router.navigate(['/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/']);
  }

  /* Cancel edit process. */
  onCancel() {
    this.isShowCancelButton = false;
    this.isShowSaveButton = false;
    this.isShowCreateButton = true;
    this.isShowNextButton = false;
    this.isShowSubmitButton = true;
    this.isShowPaymentOptions = true;
    this.isShowPayementsToPay = false;
    this.paymentStructureForm.reset();
  }

  /* Update payment plan & full pay. */
  onSave(event, form_status) {
    event.stopPropagation();
    const FORM = this.paymentStructureForm.getRawValue();

    const FEE_ID = this.routeParams.feeId;
    // full pay object
    let OBJ = {
      clubprogramfeeID: (typeof FEE_ID === 'undefined') ? 0 : FEE_ID.toString(),
      clubFeePaymentPlanID: this.clubFeePaymentPlanID,
      paymentchoice: 1,
      setup: 3,
      amount: Number(FORM.FeeAmount),
      numberofpayments: Number(0),
      dueatregistration: Number(FORM.DueAtRegistration),
      dueondate: FORM.DueOnSpecificDate,
      clubFeeStructureList: [],
      firstpaymentdueatreg: "",
      billingstartdate: "",
      payondayordate: "",
      payondatevalue: "",
      payondayvalue: "",
      PaymentNumber: 0,
      paymentfrequency: "",
      clubFeePaymentPlanList: []

    };

    console.log("Edited Information Object:", OBJ);

    event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;
    this.feesService.updateFeeStructure(OBJ).subscribe((data: any) => {
      event.target.innerHTML = 'Save';
      event.target.disabled = false;

      this.isShowNextButton = false;
      this.isShowSubmitButton = true;
      this.isShowPaymentOptions = true;
      this.isShowPayementsToPay = false;
      this.isShowSaveButton = false;
      this.isShowCreateButton = true;
      this.isShowCancelButton = false;

      this.paymentStructureForm.reset();

      this.getFeeDataNew(this.routeParams.feeId, true);
      this.alertMessage('success', data.result);
    }, error => {
      this.alertMessage('error', error.statusText);
    });
  }

  /* Save form data & payment plans. */
  onNext(event, form_status) {
    event.stopPropagation();
    if (form_status === 'VALID') {
      this.addFeeStructure();
      const FORM = this.paymentStructureForm.getRawValue();
      const FEE_ID = this.routeParams.feeId;
      //console.log("FORM:", FORM);
      const OBJ = {
        clubprogramfeeID: (typeof FEE_ID === 'undefined') ? 0 : FEE_ID.toString(),
        paymentchoice: Number(FORM.PaymentChoices),
        amount: Number(FORM.FeeAmount),
        dueatregistration: Number(FORM.DueAtRegistration),
        dueondate: FORM.DueOnSpecificDate,
        numberofpayments: Number(FORM.NumberOfPayments),
        firstpaymentdueatreg: Number(FORM.FirstPaymentDueAtRegistration),
        billingstartdate: FORM.BillingStartDate,
        payondayordate: Number(FORM.PaymentDates),
        payondatevalue: Number(FORM.OnDate), // Select Date
        payondayvalue: FORM.OnThWeek, // Day of the Week
        // PaymentNumber: 0, // Week of the Month (TODO: Dynamic)
        paymentfrequency: FORM.PaymentFrequency,
        setup: 3,
        clubFeePaymentPlanList: this.FeePaymentPlanListArray
      };
      //console.log("OBJ:", OBJ);
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.feesService.saveFeeStructure(OBJ).subscribe((data: any) => {
        event.target.innerHTML = 'Next <i class="fa fa-arrow-right"></i>';
        event.target.disabled = false;

        this.isShowNextButton = false;
        this.isShowSubmitButton = true;
        this.isShowPaymentOptions = true;
        this.isShowPayementsToPay = false;

        this.paymentStructureForm.reset();

        this.getFeeDataNew(this.routeParams.feeId, true);

        this.alertMessage('success', data.result);
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateUi();
      this.isStep3WizardNextButtonClicked = 1;
    }
  }

  /* Delete Fee Payment Plan. */
  removePaymentPlan(event, index: number, clubFeePaymentPlanID: number) {
    event.preventDefault();
    event.target.innerHTML = 'Deleting..';
    event.target.disabled = true;
    this.feesService.deleteFeePaymentPlan(clubFeePaymentPlanID).subscribe((data) => {
      event.target.innerHTML = 'Delete';
      event.target.disabled = false;
      this.getFeeDataNew(this.routeParams.feeId, true);
      this.alertMessage('success', 'Payment deleted successfully.');
      //console.log("Payment deleted successfully.");
    }, error => {
      //console.log(error);
    });
  }
  /* ======================== END Save & Delete server side. ======================== */



  /* ======================== Edit "Payment Structure & Plan ======================== */
  editPaymentPlan(event, index: number, clubFeePaymentPlanID: number, paymentChoice: number) {
    event.preventDefault();

    this.clubFeePaymentPlanID = clubFeePaymentPlanID;
    this.paymentChoice = paymentChoice;
    this.spinnerService.show();
    this.feesService.getFeePlanDetails(clubFeePaymentPlanID).subscribe((response: any) => {
      //console.log(response);
      this.spinnerService.hide();
      this.isShowCreateButton = false;
      this.isShowNextButton = false;
      this.isShowSubmitButton = false;
      this.isShowPreviousButton = true;
      this.isShowSaveButton = true;
      this.isShowCancelButton = true;
      if (this.paymentChoice == 1) {
        const rs = response.data;
        console.log("getFeePlanDetails(Full Pay):", rs);
        this.isShowPaymentOptions = false;
        this.isShowPayementsToPay = false;
        this.patchFullPayFields(rs);
      } else if (this.paymentChoice == 0) {
        const rs = response.data;
        this.isShowPaymentOptions = false;
        this.isShowPayementsToPay = true;
        //console.log("getFeePlanDetails(Payment Plan):", rs);
        //console.log("getFeePlanDetails(Payment Plan):", rs.clubFeeStructureList);
        //this.patchFeeStructurFields(rs.amount, rs.clubFeeStructureList);
      }
    });
  }

  patchFullPayFields(data) {
    this.paymentStructureForm.patchValue({
      'PaymentChoices': data.paymentchoice.toString(),
      'FeeAmount': data.amount,
      'DueAtRegistration': data.dueatregistration.toString(),
      'DueOnSpecificDate': data.dueondate.toString()
    });
    this.unlockPaymentSetup();
  }

  patchFeeStructurFields(amount, fsArray) {
    if (this.items) {
      this.clearFormArray(this.items);
    }
    this.items = this.paymentStructureForm.get('items') as FormArray;
    for (let i = 0; i < fsArray.length; i++) {
      this.items.push(this.createItem(fsArray[i].name, fsArray[i].amount, fsArray[i].duedate));
    }
    this.TotalAmountOfPayment = amount;
    this.numberOfPayments = fsArray.length;
  }
  /* ======================== END Edit "Payment Structure & Plan ======================== */
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-fee/tryout-payment-info/tryout-payment-info.component.ts